import httpUtils from '../../utils/HttpUtils'

class CustomerCartService {

  //购物车
  async customerCart () {
    let result = null;
    try {
      result = await httpUtils.post('/customer/cart');
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //加入购物车
  async joinCart (productId = '',skuId = '',quantity = 1) {
    let result = null;
    try {
      result = await httpUtils.post('/customer/cart/join',{productId,skuId,quantity});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //删除购物车商品
  async delete (cartId = '') {
    let result = null;
    try {
      result = await httpUtils.post('/customer/cart/delete',{cartId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new CustomerCartService()
